// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1czrQ","footer":"styles_footer__-8OrR","passCodeTooltip":"styles_passCodeTooltip__2nr6K"};